// custome scroll code for main dropdown
var ssb = {
    aConts: [],
    mouseY: 0,
    N: 0,
    asd: 0, // active scrollbar element
    sc: 0,
    sp: 0,
    to: 0,
  
    // constructor
    scrollbar: function (cont_id) {
      var cont = document.getElementById(cont_id);
  
      // perform initialization
      if (!ssb.init()) return false;
  
      var cont_clone = cont.cloneNode(false);
      cont_clone.style.overflow = "hidden";
      cont.parentNode.appendChild(cont_clone);
      cont_clone.appendChild(cont);
      cont.style.position = "absolute";
      cont.style.left = cont.style.top = "0px";
      cont.style.width = cont.style.height = "100%";
  
      // adding new container into array
      ssb.aConts[ssb.N++] = cont;
  
      cont.sg = false;
  
      // creating scrollbar child elements
      cont.st = this.create_div("ssb_st", cont, cont_clone);
      cont.sb = this.create_div("ssb_sb", cont, cont_clone);
      cont.su = this.create_div("ssb_up", cont, cont_clone);
      cont.sd = this.create_div("ssb_down", cont, cont_clone);
  
      // on mouse down processing
      cont.sb.onmousedown = function (e) {
        if (!this.cont.sg) {
          if (!e) e = window.event;
  
          ssb.asd = this.cont;
          this.cont.yZ = e.screenY;
          this.cont.sZ = cont.scrollTop;
          this.cont.sg = true;
  
          // new class name
          this.className = "ssb_sb ssb_sb_down";
        }
        return false;
      };
  
      // on mouse down on free track area - move our scroll element too
      cont.st.onmousedown = function (e) {
        if (!e) e = window.event;
        ssb.asd = this.cont;
  
        ssb.mouseY =
          e.clientY +
          document.body.scrollTop +
          document.documentElement.scrollTop;
        for (var o = this.cont, y = 0; o != null; o = o.offsetParent)
          y += o.offsetTop;
        this.cont.scrollTop =
          (ssb.mouseY -
            y -
            (this.cont.ratio * this.cont.offsetHeight) / 2 -
            this.cont.sw) /
          this.cont.ratio;
        this.cont.sb.onmousedown(e);
      };
  
      // onmousedown events
      cont.su.onmousedown = cont.su.ondblclick = function (e) {
        ssb.mousedown(this, -1);
        return false;
      };
      cont.sd.onmousedown = cont.sd.ondblclick = function (e) {
        ssb.mousedown(this, 1);
        return false;
      };
  
      // onmouseout events
      cont.su.onmouseout = cont.su.onmouseup = ssb.clear;
      cont.sd.onmouseout = cont.sd.onmouseup = ssb.clear;
  
      // on mouse over - apply custom class name: ssb_sb_over
      cont.sb.onmouseover = function () {
        if (!this.cont.sg) this.className = "ssb_sb ssb_sb_over";
        return false;
      };
  
      // on mouse out - revert back our usual class name 'ssb_sb'
      cont.sb.onmouseout = function () {
        if (!this.cont.sg) this.className = "ssb_sb";
        return false;
      };
  
      // onscroll - change positions of scroll element
      cont.ssb_onscroll = function () {
        this.ratio = (this.offsetHeight - 2 * this.sw) / this.scrollHeight;
        this.sb.style.top =
          Math.floor(this.sw + this.scrollTop * this.ratio) + "px";
      };
  
      // scrollbar width
      cont.sw = 12;
  
      // start scrolling
      cont.ssb_onscroll();
      ssb.refresh();
  
      // binding own onscroll event
      cont.onscroll = cont.ssb_onscroll;
      return cont;
    },
  
    // initialization
    init: function () {
      if (window.oper || (!window.addEventListener && !window.attachEvent)) {
        return false;
      }
  
      // temp inner function for event registration
      function addEvent(o, e, f) {
        if (window.addEventListener) {
          o.addEventListener(e, f, false);
          ssb.w3c = true;
          return true;
        }
        if (window.attachEvent) return o.attachEvent("on" + e, f);
        return false;
      }
  
      // binding events
      addEvent(window.document, "mousemove", ssb.onmousemove);
      addEvent(window.document, "mouseup", ssb.onmouseup);
      addEvent(window, "resize", ssb.refresh);
      return true;
    },
  
    // create and append div finc
    create_div: function (c, cont, cont_clone) {
      var o = document.createElement("div");
      o.cont = cont;
      o.className = c;
      cont_clone.appendChild(o);
      return o;
    },
  
    // do clear of controls
    clear: function () {
      clearTimeout(ssb.to);
      ssb.sc = 0;
      return false;
    },
  
    // refresh scrollbar
    refresh: function () {
      for (var i = 0, N = ssb.N; i < N; i++) {
        var o = ssb.aConts[i];
        o.ssb_onscroll();
        o.sb.style.width =
          o.st.style.width =
          o.su.style.width =
          o.su.style.height =
          o.sd.style.width =
          o.sd.style.height =
            o.sw + "px";
        o.sb.style.height =
          Math.ceil(Math.max(o.sw * 0.5, o.ratio * o.offsetHeight) + 1) + "px";
      }
    },
  
    // arrow scrolling
    arrow_scroll: function () {
      if (ssb.sc != 0) {
        ssb.asd.scrollTop += (6 * ssb.sc) / ssb.asd.ratio;
        ssb.to = setTimeout(ssb.arrow_scroll, ssb.sp);
        ssb.sp = 32;
      }
    },
  
    // scroll on mouse down
    mousedown: function (o, s) {
      if (ssb.sc == 0) {
        o.cont.sb.className = "ssb_sb ssb_sb_down";
        ssb.asd = o.cont;
        ssb.sc = s;
        ssb.sp = 400;
        ssb.arrow_scroll();
      }
    },
  
    // on mouseMove binded event
    onmousemove: function (e) {
      if (!e) e = window.event;
      ssb.mouseY = e.screenY;
      if (ssb.asd.sg)
        ssb.asd.scrollTop =
          ssb.asd.sZ + (ssb.mouseY - ssb.asd.yZ) / ssb.asd.ratio;
    },
  
    // on mouseUp binded event
    onmouseup: function (e) {
      if (!e) e = window.event;
      var tg = e.target ? e.target : e.srcElement;
      if (ssb.asd && document.releaseCapture) ssb.asd.releaseCapture();
  
      if (ssb.asd)
        ssb.asd.sb.className =
          tg.className.indexOf("scrollbar") > 0
            ? "ssb_sb ssb_sb_over"
            : "ssb_sb";
      document.onselectstart = "";
      ssb.clear();
      ssb.asd.sg = false;
    },
  };
  
  
  // After load the page 
  $(document).ready(function () {
  
    // toggle dropdown of swatch list
    $(document).on("click", ".cw_current_selected_variant", function () {
      $(this).closest(".product__color-swatches").toggleClass("active_swatches");
      ssb.refresh();
    });
  
    // change selected swatch on click of listed swatch item
    $(document).on(
      "click",
      ".main-product-section .product__top .js-enabled.product__option .product__color-swatches .product__color-swatches--inner button.product__color-swatch",
      function () {
  
        var currentTitle = $(this).attr("aria-label");
        var currentColor = $(this)
          .find("span:nth-child(1)")
          .css("background-color");
        $(".cw_current_selected_variant span:nth-child(1)").css(
          "background-color",
          currentColor
        );
        $(".cw_current_selected_variant span.cw_clr_name").html(currentTitle);
        $(".product__color-swatches").toggleClass("active_swatches");
  
        // Get the value from the .hiddenId_variant element
        // var hiddenValue = document.querySelector('.hiddenId_variant').textContent.trim();
  
        // Get all options in the #variant-selector element
        var selectElement = document.getElementById('variant-selector');
        const variantIdElement = document.querySelector('.hiddenId_variant');
        var options = selectElement.options;
  
        // Loop through each option and check if the text matches the hiddenValue
        for (var i = 0; i < options.length; i++) {
            if (options[i].text.trim() === currentTitle) {
                // If a match is found, return the value attribute of the matching option
                var matchingValue = options[i].value;
                variantIdElement.setAttribute('value',matchingValue);
                break; // Exit the loop once a match is found
            }
        }
  
      }
    );
  
    // main function for tabs and tab-content
    tabMaker();
  
    // Get class and apply custom scroll
    const scrollContainer = document.querySelector(
      ".main-product-section .product__color-swatches--inner"
    );
    $(scrollContainer).attr("id", "container2");
  
    $(window).on('load', function() {
      ssb.scrollbar("container2");
    }); // scrollbar initialization
  
    // // create a custom button of Add to cart
    // const newSubmitButton = document.createElement('button');
    // newSubmitButton.textContent = 'Add to Cart'; // Customize the button text
    // newSubmitButton.classList.add('custom-submit-button product-form__cart-submit btn btn--medium btn--full btn--primary'); // Add your custom class
    // newSubmitButton.style.cssText = 'display: block; margin-top: 10px;'; // Style it as needed
  
    // // Append the new submit button to the form or the desired container
    // const formContainer = document.querySelector('.product-form');
    // formContainer.appendChild(newSubmitButton);
  
  
  // add to cart code for custom  
    // let lastSelectedValue = '';
  
    // Function to handle color button click
    // function handleColorButtonClick(event) {
    //     const variantIdElement = document.querySelector('.hiddenId_variant');
  
    //     // Iterate through options to find a match
    //     options.forEach(option => {
    //         if (option.textContent.trim() === colorName) {
    //             variantSelector.value = option.value; // Set the matching option
    //             lastSelectedValue = option.value; // Update last selected value
    //         }
    //     });
    // }
  
  //   // Function to ensure the selected option is maintained on form submit
  //   function handleFormSubmit(event) {
  //       const formSubmitButton = document.querySelector('.product-form__cart-submit');
  
  //       function checkAndSelectOption() {
  //           // Check if the button has the 'loading' class
  //           if (formSubmitButton.classList.contains('loading')) {
  //               // If 'loading' class is present, check again after 100ms
  //               setTimeout(checkAndSelectOption, 100);
  //           } else {
  //               // If 'loading' class is not present, set the selected option after 1 second
  //               setTimeout(() => {
  //                   const variantSelector = document.querySelector('#variant-selector');
  //                   variantSelector.value = lastSelectedValue; // Set the last selected value
  //               }, 1000); // 1 second delay
  //           }
  //       }
  
  //       // Start checking if the button has the 'loading' class
  //       checkAndSelectOption();
  //   }
  
  //   // Function to maintain the last selected value using setInterval
  //   function maintainSelectedValue() {
  //       const variantSelector = document.querySelector('#variant-selector');
  //       if (variantSelector) {
  //           variantSelector.value = lastSelectedValue;
  //       }
  //   }
  
  //   // Attach event listeners
    // const colorButtons = document.querySelectorAll('.color-button');
    // colorButtons.forEach(button => {
    //     button.addEventListener('click', handleColorButtonClick);
    // });
  
    // const formSubmitButton = document.querySelector('.product-form__cart-submit');
    // const formElement = document.querySelector('form.product-form');
    // if (formSubmitButton) {
    //     formSubmitButton.addEventListener('click', setIdInputValue("44533823733913"));
    // }
  
    // const setIdInputValue = value => {
    //   let idInputElement = document.querySelector('input[name="id"]');
    //   if (!idInputElement) {
    //     idInputElement = document.createElement("input");
    //     idInputElement.type = "hidden";
    //     idInputElement.name = "id";
    //     formElement.appendChild(idInputElement);
    //   }
    //   idInputElement.value = value.toString();
    // };
  
  //   // Set an interval to maintain the last selected value
  //   setInterval(maintainSelectedValue, 1); // Check every 100ms
  
  });
  
  function tabMaker() {
    // variables initialization
    const swatchesWrapper = document.querySelector(
      ".main-product-section .product .product__color-swatches"
    );
  
    const swatchesInner = document.querySelector(
      ".product__color-swatches--inner"
    );
  
  
    // check active class for main dropdown
    if (
      swatchesWrapper &&
      swatchesWrapper.classList.contains("active_swatches")
    ) {
      // Remove the class 'active_swatches' from the element
      swatchesWrapper.classList.remove("active_swatches");
    }
  
  
  // check for absent of swatchlist
    if (!swatchesInner) {
      console.error("Swatches container not found in the DOM.");
      return;
    }
  
    const swatches = Array.from(swatchesInner.children); // make array of all swatch
  
  // get all tab from dom and push in array
    let tabs = [];
    const tabLinks = document.querySelectorAll(".tabs .tablinks");
  
    tabLinks.forEach((tab) => {
      tabs.push(tab.textContent.trim());
    });
  
  // get all tab-content from dom and push in object
    let tabContent = {};
    // Loop through each .tabcontent element
    document.querySelectorAll(".tabcontent").forEach((tabElement) => {
      // Get the category name from the tab element's ID (you can modify this as needed)
      let category = tabElement.id;
  
      // Initialize an array for this category in tabContent object
      if (!tabContent[category]) {
        tabContent[category] = [];
      }
  
      // Loop through each button inside the .tabcontent
      tabElement.querySelectorAll("button.color-button").forEach((button) => {
        // Get the data-color attribute, trim any excess spaces, and add it to the category array
        let color = button.getAttribute("data-color").trim();
        tabContent[category].push(color);
      });
    });
  
    // Fetch all variant elements and create a mapping
    const variantElements = document.querySelectorAll(
      ".main-product-section .product .product__color-swatch"
    );
    const variantColors = {};
  
    variantElements.forEach((element) => {
      const variantLabel = element.querySelector(".cw-vairnat-text");
      const variantLabelText = variantLabel.innerText.toUpperCase();
      const variantColor =
        variantLabel.previousElementSibling.style.backgroundColor;
  
      if (variantLabelText && variantColor) {
        variantColors[variantLabelText] = variantColor;
      }
    });
  
    tabs.forEach((tab) => {
      let tab_item = tab.replaceAll(" ", "-");
      let button = document.querySelector(`button.tablinks[data-tab="${tab}"]`);
      button.addEventListener("click", (evt) => openTab(evt, tab_item));
    });
  
    // Create the tab content
    Object.keys(tabContent).forEach((tab) => {
      if (Array.isArray(tabContent[tab])) {
        tabContent[tab].forEach((item) => {
          // Find the button element from the DOM
          let button = document.querySelector(
            `button.color-button[data-color="${item}"]`
          ); // Adjust the selector as needed
          if (button) {  
            // Add event listener to the button
            button.addEventListener("click", () => console.log("test",button));
          }else{
              console.error("no button found");
          }
        });
      } else {
        tabDiv.innerHTML = `<h3>${tab}</h3><p>${tabContent[tab]}</p>`;
      }
    });
  
    // handle selected swatch on load and on click
    function selectOptionHandler2(optionName) {
      const currentSwatches = Array.from(swatchesInner.children);
      currentSwatches.forEach((swatch) => {
        let labelData = swatch.dataset.label.split("+")[0];
        if (labelData === optionName) {
          swatch.click();
          swatchesWrapper.classList.remove("active_swatches");
        }
      });
    }
  
    function openTab(evt, tabName) {
      const tabContents = document.querySelectorAll(".tabcontent");
      const tabLinks = document.querySelectorAll(".tablinks");
      tabContents.forEach((content) => content.classList.remove("active"));
      tabLinks.forEach((link) => link.classList.remove("active"));
  
      document.getElementById(tabName).classList.add("active");
      evt.currentTarget.classList.add("active");
  
      // Add "is-active" class to the first button in the tab content
      const firstButton = document.querySelector(`#${tabName} .color-button`);
      if (firstButton) {
        firstButton.classList.add('is-active');
      }
      
      let firstSelected = firstButton.innerText.trim();
      sortAndFilterSwatches(tabName);
      selectOptionHandler2(firstSelected);
  
      // manage swatch on change on tabs
      document.getElementById(tabName).querySelectorAll('li').forEach(function(ele) {
          ele.querySelectorAll('button').forEach(function(item) {
              let swatchItem = item.innerText.trim();
              item.addEventListener('click', function() {
                  selectOptionHandler(swatchItem);
              });
          });
      });
      
    }
  
    document.querySelector(".tablinks").click();
  
    // Change list of items
    function sortAndFilterSwatches(tabName) {
      const selectedColors = tabContent[tabName];
      // Filter swatches by selected tab content
      const filteredSwatches = selectedColors
      .map((color) => {
        console.log("color List:", color);
        const swatch = swatches.find((swatch) => swatch.dataset.swatch_item.includes(` ${color} `));
        if(color === " C4"){
        console.log("swatch List:", swatch);
        }else{
          console.log("no found!!");
        }
        return swatch;
      })
      .filter((swatch) => swatch !== undefined);
      // Clear current swatchesInner content and append sorted filtered swatches
      swatchesInner.innerHTML = "";
      filteredSwatches.forEach((swatch) => {
        swatchesInner.appendChild(swatch)});
    }
  
    // Function to handle button click within a tab content
    function selectOptionHandler(optionName) {
      const variantIdElement = document.querySelector('.hiddenId_variant');
      let currentTab = document
        .querySelector(".tablinks.active")
        .innerText.trim();
      currentTab = currentTab.replaceAll(" ", "-");
      const currentSwatches = Array.from(
        document.querySelectorAll(`#${currentTab} .color-button`)
      );
  
      currentSwatches.forEach((button) => {
        if ($(button).is(":visible")) {
          if (button.innerText === optionName) {
            $(button).addClass("is-active");
          } else {
            $(button).removeClass("is-active");
          }
        }
      });
  
      variantIdElement.setAttribute('value',optionName);
  
      // Simulate click on the swatch based on the optionName
      selectOptionHandler2(optionName);
    }
  
    swatches.forEach((swatch) => {
      swatch.addEventListener("click", function () {
        const swatchLabel = this.dataset.label.split("+")[0];
        selectOptionHandler(swatchLabel);
        swatchesWrapper.classList.toggle("active_swatches");
      });
    });
  }
  
  
  
  